
export default {
  name: 'Breadcrumbs',
  props: {
    items: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    color() {
      return this.$vuetify.theme.isDark ? 'grey lighten-3' : 'grey darken-3'
    }
  }
}
